import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import authAtom from '~/recoil/atom/auth';

import { PLATFORM_ID } from '~/globalVariables';

import { platformCustomerListener } from '~/firebase/listeners/platform';
import { SnapshotFn } from '~/firebase/listeners/type';

import { Customer } from '~/types/platform/customer';

import * as fp from 'lodash/fp';

export default function useContainerCount() {
  const auth = useRecoilValue(authAtom);
  const [containerCount, setContainerCount] = useState<number>(0);

  const calcCounts = (container: Record<string, number>) => {
    return fp.sum(Object.values(container));
  };

  const handleCustomerListener: SnapshotFn = async (doc) => {
    if (doc.exists()) {
      const { containers } = doc.data() as Customer;

      const newCount = fp.sumBy(calcCounts)(Object.values(containers));

      setContainerCount(newCount);
    } else {
      setContainerCount(0);
    }
  };

  useEffect(() => {
    if (auth) {
      const unlisten = platformCustomerListener(PLATFORM_ID, auth.uid, handleCustomerListener);
      return () => {
        unlisten();
      };
    }
  }, [auth]);

  return {
    containerCount,
  };
}
